<template>
    <div>
        <div v-show="menuState == 0">
            <button @click="goBack" class="back-button"><img class="icon-in-button" :src="require('@/assets/dashboard/angle-left-solid-dark-grey.svg')" alt="Icon" /></button>
            <h3>Passwort zurücksetzen</h3>
            <form id="password-reset-request" action="/reset-password" method="post">
                <!-- Bei echten Anwendungen hier CSRF-Token einfügen -->
                <div class="flex">
                    <div class="input-container">
                        <label for="email">Bitte geben Sie Ihre E-Mail-Adresse ein:</label>
                        <input type="email" id="email" name="email" required placeholder="max.mustermann@web.de">
                    </div>
                    <button @click="sendPasswordLink" class="btn">Link senden</button>
                </div>
            </form>
        </div>
        <div class="password-send-successful-container" v-show="menuState == 1">
            <div>Wir haben Ihnen einen Link zum Zurücksetzen des Passworts an Ihre hinterlegte Email-Adresse versendet.</div>
        </div>
    </div>
</template>

<script>

export default {
    components: {
        
    },
    data() {
      return {
        menuState: 0,
      }
    },
    methods: {
        goBack() {
            this.$parent.changeMenuState(0);
        },
        changeMenuState(menuState) { 
            this.menuState = menuState;
        },
        sendPasswordLink() {
            this.changeMenuState(1);
            setTimeout(this.goBack, 4000);
        }
    },
  }

</script>

<style scoped src="@/styles/ForgotPassword.css">

</style>